import compose from '../../../../lib/compose';
import connect from '../../../../store/connect';
import withFeatureFlag from '../../../../components/feature-flag/with-feature-flag';
import jsonToProps from '../../../../components/enhanced-content/helpers/json-to-props';

const FEATURE_NAME = 'enhanced_content';

const mapStateToProps = state => {
  const enhancedContent = state.components[FEATURE_NAME];
  return {
    ...jsonToProps(enhancedContent, state.parentUrl),
    id: state.id,
  };
};

const enhance = compose(
  withFeatureFlag(FEATURE_NAME),
  connect(mapStateToProps),
);

const component = Component => enhance(Component);

export default component;
